import React, { useEffect, useState } from 'react';

//import components
import DynamicMenu from './DynamicMenu';
import SidebarContent from './SidebarContent';
import { useGetPermissionWiseMenuQuery } from 'src/rtk/features/permissions/permissionApi';

const Sidebar = (props: any) => {
  const [isDynamicMenu, setIsDynamicMenu] = useState<boolean>(true);
  const [isDynamicMenuBtn, setIsDynamicMenuBtn] = useState<boolean>(true);
  const [menus, setMenus] = useState<any>([]);
  const {data : allMenu, isSuccess} = useGetPermissionWiseMenuQuery();

  useEffect(() => {
    if(allMenu && isSuccess){
      setMenus(allMenu?.data?.menus);
    }
  },[allMenu, isSuccess]);

  const closeMobileSidebar = () => {
    document.body.classList.remove('sidebar-enable');
  };

  const handleSidebarClick = (event: React.MouseEvent<HTMLDivElement>) => {
    const navigationLink = (event.target as HTMLElement).closest(
      'a[data-sidebar-navigate="true"]',
    );

    if (window.innerWidth <= 992 && navigationLink) {
      closeMobileSidebar();
    }
  };

  return (
    <React.Fragment>
      <div className="vertical-menu" onClick={handleSidebarClick}>
        <button
          type="button"
          className="mobile-sidebar-close"
          onClick={closeMobileSidebar}
          aria-label="Close navigation menu"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div data-simplebar className="h-100">
          {/* {isDynamicMenuBtn && (
            <div
              className="btn btn-sm btn-primary mt-1 mx-3"
              onClick={() => setIsDynamicMenu(!isDynamicMenu)}
            >
              Show {!isDynamicMenu ? 'Dynamic' : 'Static'} Menu
            </div>
          )} */}
          {/* {!isDynamicMenu && props.type !== 'condensed' && isSuccess ? ( */}
            <DynamicMenu 
              menus={menus}
            />
          {/* ) : (
            <SidebarContent />
          )} */}
        </div>
      </div>
    </React.Fragment>
  );
};

export default Sidebar;
